import * as yup from 'yup'

import type { TBookingCart } from '@providers/booking/types'
import { i18WithDefault as t } from '@shared/locale'
import {
  isCheckInTimeEnabled,
  isCheckInTimeRequired,
  isCheckOutTimeEnabled,
  isCheckOutTimeRequired,
} from 'components-ui/src/shared/location'
import { BookingReservationClientDto } from 'service-api/src/types/api'

export const hasRequiredArrivalTimeValues = (
  reservation: BookingReservationClientDto | undefined,
  values: { checkInTime?: string; checkOutTime?: string }
): boolean => {
  const conf = reservation?.locationBookingConf
  if (!conf) {
    return false
  }
  if (isCheckInTimeEnabled(conf) && isCheckInTimeRequired(conf) && !values.checkInTime) {
    return false
  }
  if (isCheckOutTimeEnabled(conf) && isCheckOutTimeRequired(conf) && !values.checkOutTime) {
    return false
  }
  return true
}

export const arrivalTimesSchema = (reservation: BookingReservationClientDto) => {
  const schema: Record<string, yup.StringSchema> = {}

  if (isCheckInTimeEnabled(reservation.locationBookingConf!)) {
    schema.checkInTime = yup.string().label(t('checkInOutForm.checkIn'))
    if (isCheckInTimeRequired(reservation.locationBookingConf!)) {
      schema.checkInTime = schema.checkInTime.required()
    }
  }
  if (isCheckOutTimeEnabled(reservation.locationBookingConf!)) {
    schema.checkOutTime = yup.string().label(t('checkInOutForm.checkOut'))
    if (isCheckOutTimeRequired(reservation.locationBookingConf!)) {
      schema.checkOutTime = schema.checkOutTime.required()
    }
  }

  return yup.object().shape(schema)
}

export const arrivalTimesInitialValues = (cart: TBookingCart) => ({
  checkInTime: cart?.checkInTime || '',
  checkOutTime: cart?.checkOutTime || '',
})
